<p-panel>
    <app-reactive-form-builder #builderRef [form]="form.formFields"
        [serverUrl]="form.env.serverUrl" [id]="reactiveFormRecordId"
        [request]="request"
        [getRequest]="tratamientosApi.tratamientosGET" [previousData]="initialPreviousData"
        (stableValueChanges)="stableValueChanges($event)" (goBack)="goBack()">
    </app-reactive-form-builder>
</p-panel>
